import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-24 pb-16 px-4" data-id="element-56">
      <div className="max-w-5xl mx-auto text-center" data-id="element-57">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight mb-6" data-id="element-58">
          Puedes ser un gran profesor de pádel… y aun así{' '}
          <span className="text-accent" data-id="element-59">
            no ganar dinero de forma constante
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto" data-id="element-60">
          Descubre el sistema simple que algunos profesores están usando para
          conseguir más alumnos, cobrar mejor y dejar de depender solo de las
          clases por hora.
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} onClick={scrollToOffer} className="bg-primary hover:bg-green-600 text-white font-bold text-lg px-12 py-5 rounded-lg shadow-xl hover:shadow-2xl transition-all transform hover:scale-105" data-id="element-61">
          Ver cómo funciona
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12 cursor-pointer" onClick={scrollToOffer} data-id="element-62">
          <img src="https://cdn.magicpatterns.com/uploads/heLoZZWJL3TJgHxcNkBzoG/Combinacion_completa_para_entrenadores_de_padel.png" alt="Megapack Pádel Listo" className="w-full max-w-3xl mx-auto hover:scale-105 transition-transform duration-300 drop-shadow-[0_0_30px_rgba(132,204,22,0.15)]" style={{
          mixBlendMode: 'lighten'
        }} data-id="element-63" />
        </motion.div>
      </div>
    </section>;
}